import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getClassDistributionSummary = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.GRAPHICAL_REPORT.GET_CLASS_DISTRIBUTION_SUMMARY
  );
};

export default getClassDistributionSummary;
